var _mask, _mask2, _mask3, _mask4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgScs = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 234 52",
    height: 52,
    viewBox: "0 0 234 52",
    width: 234,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo Slotcoordination") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 23.6,
    maskUnits: "userSpaceOnUse",
    width: 14.4,
    x: 0.4,
    y: -0.2
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m.4-.2h14.4v23.6h-14.4z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    height: 16.8,
    maskUnits: "userSpaceOnUse",
    width: 13.2,
    x: 0.5,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m.5 0h13.1v16.8h-13.1z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    height: 17.1,
    maskUnits: "userSpaceOnUse",
    width: 15.3,
    x: 0.5,
    y: -0.2
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m.5-.2h15.3v17.2h-15.3z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    height: 17.1,
    maskUnits: "userSpaceOnUse",
    width: 14.2,
    x: 0.3,
    y: -0.2
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m.3-.2h14.2v17.2h-14.2z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#db4440"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 34h50v-5h-50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 52h17v-5h-17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 43h34v-5h-34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.2 27.6v7.7h-7.7v8.7h7.7v7.7h8.9v-7.7h7.7v-8.8h-7.8v-7.7h-8.8zm-5.6 9.7h7.7v-7.7h4.7v7.7h7.7v4.7h-7.7v7.7h-4.7v-7.7h-7.7z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#525252",
    transform: "translate(0 .219049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.1 22.1 1.1-2.8c.6.4 1.3.8 2.2 1.1s1.6.4 2.3.4c1.2 0 2.2-.3 2.9-1s1.1-1.5 1.1-2.5c0-.8-.2-1.5-.6-2.1-.4-.7-1.4-1.4-3.1-2.2l-1.8-.8c-1.6-.7-2.6-1.6-3.2-2.6-.7-1-1-2.2-1-3.6 0-1.7.6-3.1 1.8-4.2s2.7-1.6 4.6-1.6c2.5 0 4.3.4 5.2 1.2l-.9 2.7c-.4-.3-1-.6-1.9-.9-.8-.3-1.6-.4-2.3-.4-1.1 0-1.9.3-2.5.9s-.9 1.3-.9 2.3c0 .6.1 1.1.3 1.6.2.4.6.8.9 1.1.4.3 1.2.8 2.4 1.4l1.9.9c1.6.7 2.6 1.6 3.3 2.6.6 1 .9 2.3.9 3.9 0 1.7-.7 3.1-2.1 4.3s-3.2 1.8-5.5 1.8c-2-.1-3.7-.6-5.1-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.9 18.5v-18.7h2.9v18.2c0 .9.3 1.6.8 2.1s1.2.8 2 .8v2.6c-3.8-.1-5.7-1.7-5.7-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4 14.8c0 4.1 1.5 6.2 4.4 6.2 1.4 0 2.5-.6 3.2-1.7.8-1.1 1.2-2.6 1.2-4.5 0-4.1-1.5-6.1-4.4-6.1-1.3 0-2.4.5-3.2 1.6s-1.2 2.6-1.2 4.5m-3.1 0c0-2.5.7-4.6 2.1-6.2s3.2-2.4 5.5-2.4c2.4 0 4.2.8 5.5 2.3s2 3.6 2 6.3-.7 4.8-2 6.3-3.2 2.3-5.5 2.3c-2.4 0-4.2-.8-5.5-2.3-1.5-1.5-2.1-3.6-2.1-6.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.9 8.9h-1.9v-2.3h1.9v-3.4l2.9-1.2v4.6h4.6v2.3h-4.6v8.2c0 1.4.2 2.4.7 3s1.2.9 2.3.9c.8 0 1.5-.2 2.3-.6l.4 2.6c-1.2.3-2.6.5-4 .5-1.3 0-2.4-.5-3.3-1.5s-1.4-2.2-1.4-3.7v-9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77 1.3-1 2.6c-1-.7-2.6-1.1-4.7-1.1-2 0-3.6.9-4.8 2.6s-1.8 3.9-1.8 6.6c0 2.6.6 4.7 1.9 6.3 1.2 1.6 2.8 2.4 4.8 2.4 2.1 0 3.8-.8 4.9-2.3l1.7 2.4c-1.8 1.8-4.1 2.7-7 2.7-3 0-5.3-1.1-7-3.2s-2.6-4.9-2.6-8.4c0-3.4.9-6.2 2.7-8.4s4.2-3.3 7.1-3.3c2.4-.1 4.4.3 5.8 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.5 14.8c0 4.1 1.5 6.2 4.4 6.2 1.4 0 2.5-.6 3.2-1.7.8-1.1 1.2-2.6 1.2-4.5 0-4.1-1.5-6.1-4.4-6.1-1.3 0-2.4.5-3.2 1.6s-1.2 2.6-1.2 4.5m-3.1 0c0-2.5.7-4.6 2.1-6.2s3.2-2.4 5.5-2.4c2.4 0 4.2.8 5.5 2.3s2 3.6 2 6.3-.7 4.8-2 6.3-3.2 2.3-5.5 2.3c-2.4 0-4.2-.8-5.5-2.3-1.4-1.6-2.1-3.7-2.1-6.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.6 14.8c0 4.1 1.5 6.2 4.4 6.2 1.4 0 2.5-.6 3.2-1.7.8-1.1 1.2-2.6 1.2-4.5 0-4.1-1.5-6.1-4.4-6.1-1.3 0-2.4.5-3.2 1.6s-1.2 2.6-1.2 4.5m-3.1 0c0-2.5.7-4.6 2.1-6.2s3.2-2.4 5.5-2.4c2.4 0 4.2.8 5.5 2.3s2 3.6 2 6.3-.7 4.8-2 6.3-3.2 2.3-5.5 2.3c-2.4 0-4.2-.8-5.5-2.3-1.4-1.6-2.1-3.7-2.1-6.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.4 9.4c-.6-.4-1.3-.7-1.9-.7-1 0-2 .5-2.7 1.4-.8 1-1.2 2.1-1.2 3.5v9.5h-2.9v-16.5h2.9v2.6c1.1-2 2.7-2.9 4.8-2.9.5 0 1.3.1 2.3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.9 10.4c-.7-1.1-1.8-1.7-3.1-1.7-1.6 0-2.8.6-3.8 1.8s-1.5 2.7-1.5 4.5c0 4 1.8 6 5.5 6 .5 0 1-.1 1.7-.4s1.1-.6 1.2-.9zm0 12.7v-1.2c-1 1-2.5 1.5-4.5 1.5-2.1 0-3.8-.7-5.1-2.2s-1.9-3.5-1.9-5.9c0-2.5.7-4.6 2.2-6.3 1.5-1.9 3.3-2.8 5.4-2.8 1.7 0 3 .4 3.9 1.2v-7.7h2.9v23.3h-2.9z",
    mask: "url(#a)",
    transform: "translate(124.397079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.8.3c.5 0 .9.2 1.3.5.4.4.5.8.5 1.3s-.2.9-.5 1.3c-.4.4-.8.5-1.3.5s-.9-.2-1.3-.5c-.4-.4-.5-.8-.5-1.3s.2-.9.5-1.3c.3-.3.8-.5 1.3-.5zm-1.6 22.8v-14.1h-2.3v-2.4h5.2v16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.4 23.1v-9.6c0-1.8-.3-3-.8-3.7s-1.4-1.1-2.7-1.1c-.7 0-1.4.2-2.1.6s-1.3.9-1.7 1.5v12.3h-2.9v-16.5h2l.9 2.1c1-1.6 2.6-2.4 4.8-2.4 3.6 0 5.5 2.2 5.5 6.6v10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177 15c-.9-.2-1.6-.3-2-.3-1.5 0-2.7.4-3.6 1.1-.9.8-1.4 1.7-1.4 2.7 0 1.7 1 2.6 3.1 2.6 1.5 0 2.8-.7 4-2.1v-4zm.3 6.2c-1.2 1.5-3 2.2-5.4 2.2-1.3 0-2.4-.5-3.4-1.4s-1.4-2.1-1.4-3.5c0-1.7.7-3.1 2.2-4.2 1.5-1.2 3.4-1.7 5.6-1.7.6 0 1.3.1 2.1.4 0-2.7-1.2-4-3.6-4-1.8 0-3.3.5-4.3 1.5l-1.1-2.6c.6-.5 1.3-.8 2.3-1.2 1-.3 1.9-.5 2.8-.5 2.4 0 4.2.5 5.3 1.6s1.6 2.8 1.6 5.2v6c0 1.4.4 2.4 1.3 2.9v1.5c-1.2 0-2.1-.2-2.7-.5-.6-.4-1-.9-1.3-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.5 8.9h-1.9v-2.3h1.9v-3.5l2.9-1.1v4.6h4.6v2.3h-4.6v8.2c0 1.4.2 2.4.7 3s1.2.9 2.3.9c.8 0 1.5-.2 2.3-.6l.4 2.6c-1.2.3-2.6.5-4 .5-1.3 0-2.4-.5-3.3-1.5s-1.4-2.2-1.4-3.7v-9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.5.3c.5 0 .9.2 1.3.5.4.4.5.8.5 1.3s-.2.9-.5 1.3c-.4.4-.8.5-1.3.5s-.9-.2-1.3-.5c-.4-.4-.5-.8-.5-1.3s.2-.9.5-1.3c.3-.3.8-.5 1.3-.5zm-1.6 22.8v-14.1h-2.3v-2.4h5.2v16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206 14.8c0 4.1 1.5 6.2 4.4 6.2 1.4 0 2.5-.6 3.2-1.7.8-1.1 1.2-2.6 1.2-4.5 0-4.1-1.5-6.1-4.4-6.1-1.3 0-2.4.5-3.2 1.6s-1.2 2.6-1.2 4.5m-3.1 0c0-2.5.7-4.6 2.1-6.2s3.2-2.4 5.5-2.4c2.4 0 4.2.8 5.5 2.3s2 3.6 2 6.3-.7 4.8-2 6.3-3.2 2.3-5.5 2.3c-2.4 0-4.2-.8-5.5-2.3-1.5-1.6-2.1-3.7-2.1-6.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.7 16.8v-9.6c0-1.8-.3-3-.8-3.7-.6-.7-1.4-1-2.7-1-.7 0-1.4.2-2.1.6s-1.3.9-1.7 1.5v12.3h-2.9v-16.6h2l.9 2.1c1-1.6 2.6-2.4 4.8-2.4 3.6 0 5.5 2.2 5.5 6.6v10.2z",
    mask: "url(#b)",
    transform: "translate(220.371086 6.227158)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.4 50.3 1.1-2.8c.6.4 1.3.8 2.2 1.1s1.6.4 2.3.4c1.2 0 2.2-.3 2.9-1s1.1-1.5 1.1-2.5c0-.8-.2-1.5-.6-2.1-.4-.7-1.4-1.4-3.1-2.1l-1.8-.8c-1.6-.7-2.6-1.6-3.2-2.6s-.9-2.2-.9-3.6c0-1.7.6-3.1 1.8-4.2s2.7-1.7 4.6-1.7c2.5 0 4.3.4 5.2 1.2l-.9 2.7c-.4-.3-1-.6-1.9-.9-.8-.3-1.6-.4-2.4-.4-1.1 0-1.9.3-2.5.9s-.9 1.4-.9 2.3c0 .6.1 1.1.3 1.6s.5.9.9 1.2 1.2.8 2.4 1.3l1.9.9c1.6.7 2.6 1.6 3.3 2.6.6 1 .9 2.3.9 3.9 0 1.7-.7 3.1-2.1 4.3s-3.2 1.8-5.5 1.8c-1.9-.1-3.6-.6-5.1-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.6 51.6h-.7l-4.9-11.2-4.9 11.2h-.7l-6-16.8h3.2l3.5 10.8 4.4-10.8h.8l4.6 10.8 3.8-10.8h2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.3 28.6c.5 0 .9.2 1.3.5.4.4.5.8.5 1.3s-.2.9-.5 1.3c-.4.4-.8.5-1.3.5s-.9-.2-1.3-.5c-.4-.4-.5-.8-.5-1.3s.2-.9.5-1.3c.4-.4.8-.5 1.3-.5zm-1.6 22.7v-14h-2.3v-2.5h5.2v16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.6 48.9h9.2v2.6h-13.8v-.8l9.4-13.1h-9.3v-2.6h13.6v.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.4 2.3c-1.3 0-2.4.4-3.3 1.3-.8.8-1.3 1.8-1.4 3h9.2c0-1.2-.4-2.2-1.1-3-.9-.9-2-1.3-3.4-1.3m7.1 6.4h-12c0 1.9.5 3.4 1.6 4.5.9.9 2.2 1.4 3.6 1.4 1.7 0 3.1-.5 4.2-1.5l1.2 2.1c-.5.5-1.2.8-2.1 1.2-1 .4-2.3.6-3.8.6-2.1 0-3.9-.7-5.3-2.1-1.6-1.6-2.4-3.6-2.4-6.3s.8-4.9 2.5-6.6c1.5-1.5 3.3-2.2 5.3-2.2 2.4 0 4.2.7 5.6 2 1.3 1.3 2 3 2 5.1-.1.7-.2 1.3-.4 1.8",
    mask: "url(#c)",
    transform: "translate(148.390581 34.798824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.7 37.8c-.6-.4-1.3-.7-1.9-.7-1 0-2 .5-2.7 1.4-.8 1-1.2 2.1-1.2 3.5v9.5h-2.9v-16.5h2.9v2.6c1.1-2 2.7-2.9 4.8-2.9.5 0 1.3.1 2.3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179 46.8v-18.6h2.9v18.1c0 .9.3 1.6.8 2.1s1.2.8 2 .8v2.6c-3.8 0-5.7-1.7-5.7-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.3 8.6c-.9-.2-1.6-.3-2-.3-1.5 0-2.7.4-3.6 1.1-.9.8-1.4 1.7-1.4 2.7 0 1.7 1 2.6 3.1 2.6 1.5 0 2.8-.7 4-2.1v-4zm.3 6.2c-1.2 1.5-3 2.2-5.4 2.2-1.3 0-2.4-.5-3.4-1.4s-1.4-2.1-1.4-3.5c0-1.7.7-3.1 2.2-4.2 1.4-1.2 3.3-1.8 5.6-1.8.6 0 1.3.1 2.1.4 0-2.7-1.2-4-3.6-4-1.9 0-3.3.5-4.3 1.5l-1.2-2.5c.6-.5 1.3-.8 2.3-1.2 1-.3 1.9-.5 2.8-.5 2.4 0 4.2.5 5.3 1.6s1.6 2.8 1.6 5.2v5.9c0 1.4.4 2.4 1.3 2.9v1.6c-1.2 0-2.1-.2-2.7-.5-.5-.4-1-.9-1.2-1.7z",
    mask: "url(#d)",
    transform: "translate(186.411053 34.798824)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.9 51.5v-9.6c0-1.8-.3-3-.8-3.7s-1.4-1.1-2.7-1.1c-.7 0-1.4.2-2.1.6s-1.3.9-1.7 1.5v12.3h-2.9v-16.5h2l.9 2.1c1-1.6 2.6-2.4 4.8-2.4 3.6 0 5.5 2.2 5.5 6.6v10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231 38.8c-.7-1.1-1.8-1.7-3.1-1.7-1.6 0-2.9.6-3.8 1.8-1 1.2-1.5 2.7-1.5 4.5 0 4 1.8 6 5.5 6 .5 0 1-.1 1.7-.4s1.1-.6 1.2-.9zm0 12.7v-1.2c-1 1-2.5 1.5-4.5 1.5-2.1 0-3.8-.7-5.1-2.2s-1.9-3.5-1.9-5.9c0-2.5.7-4.6 2.2-6.3 1.5-1.8 3.3-2.6 5.3-2.6 1.7 0 3 .4 3.9 1.2v-7.7h2.9v23.3h-2.8z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SCS.2d81899fa0b70a1d5ea8ec54e709043a.svg";